import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {Card, CardContent} from "@mui/material";
import {useNavigate} from "react-router-dom";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    outline: "none",
};

const RecommendedCancelMessage = ({openCancelModal, handleCloseCancelModal}) => {

    const navigate = useNavigate();

    return (
        <Modal open={openCancelModal} onClose={handleCloseCancelModal}>
            <Card sx={style}>
                <CardContent
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        textAlign: "center",
                        gap: "15px",
                    }}
                >
                    <Typography sx={{fontSize: "16px", fontWeight: "bold"}}>
                        آیا مطمئن هستید؟
                    </Typography>
                    <Typography sx={{fontSize: "14px"}}>
                        در صورت ترک این صفحه تنظیمات شما ذخیره نخواهد شد
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "15px",
                        }}
                    >
                        <button
                            onClick={() => navigate("/dashboard/recommended")}
                            className="btn btn-blue"
                        >
                            انصراف
                        </button>
                        <button
                            onClick={handleCloseCancelModal}
                            className="btn btn-softred"
                        >
                            لغو
                        </button>
                    </Box>
                </CardContent>
            </Card>
        </Modal>
    );
};

export default RecommendedCancelMessage;
